import {FlatpickrFn} from "flatpickr/dist/types/instance";
import {AbstractItem} from "./abstract-task";

export class Task extends AbstractItem {
  constructor(item: HTMLElement, flatpickr: FlatpickrFn, type: string) {
    super(item, flatpickr, type);
  }
}
